// test543
(543 && 0);
